import { createApp } from 'vue'
import router from './router'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'

import '@vue-js-cron/vuetify/dist/vuetify.css'


// registers the component globally
// registered name: CronVuetify
import CronVuetifyPlugin from '@vue-js-cron/vuetify'
import CronCorePlugin from '@vue-js-cron/core'

import authModule from './modules/authModule'
import payrollModule from './modules/payrollModule'
import analyticsModule from './modules/analyticsModule'
import revenueModule from './modules/revenueModule'
import financialModelingModule from './modules/financialModelingModule'

import { registerModules } from './registerModules'
import adminModule from './modules/adminModule'

loadFonts()

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

registerModules({
    auth: authModule,
    payroll: payrollModule,
    admin: adminModule,
    analytics: analyticsModule,
    revenue: revenueModule,
    modeling: financialModelingModule
})

createApp(App)
  .use(pinia)
  .use(router)
  .use(vuetify)
  .use(CronVuetifyPlugin)
  .use(CronCorePlugin)
  .mount('#app')